import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

const MainSlider = ({ thumbsSwiper, slides }) => {
    return (


        <Swiper
            modules={[Navigation, Thumbs, Autoplay]}
            // navigation
            autoplay={{ delay: 3000 }}
            thumbs={{ swiper: thumbsSwiper }}
            loop
            className="main-swiper"
            slidesPerView={1}

        >
            {slides.map((slide, index) => (
                <SwiperSlide key={index} >
                    <div className="slide-content" data-product={index}>{slide.content}</div>
                </SwiperSlide>

            ))}
        </Swiper>
    );
};

export default MainSlider;
